module.exports = __WEBPACK_EXTERNAL_MODULE_31__;


//////////////////
// WEBPACK FOOTER
// external {"root":"Vue","commonjs2":"vue","commonjs":"vue","amd":"vue"}
// module id = 31
// module chunks = 0 1